import * as React from 'react'
import Layout from '../layouts/defaultLayout'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import { styles } from './../pagesStyles/notFoundStyles'
import { Typography } from '@material-ui/core'
import CHRButton from '../components/button'
import CHRContentContainer from '../components/contentContainer'
import CHRSectionContainer from '../components/sectionContainer'
import chirpyestIcon from './../assets/images/chirpyest-logo.svg'
import { navigate } from 'gatsby'
import { ROUTES } from '../constants'
import SEO from '../components/seo'

interface NotFoundPageProps {
  t: TFunction
  error?: string
  // Client-only routes (e.g. /cullector/<slug>) render this with an HTTP 200, so the robots
  // tag is what keeps a missing page out of the index. Pass false when the page may exist
  // but its data failed to load, so a transient API error cannot deindex a real URL.
  noindex?: boolean
}

const NotFoundPage = ({ t, error, noindex = true }: NotFoundPageProps) => {
  const classes = styles()

  return (
    <Layout>
      <SEO title={t('notFound.metaTitle')} noindex={noindex} />
      <CHRSectionContainer>
        <CHRContentContainer>
          <div className={classes.container}>
            <img
              src={chirpyestIcon}
              alt={t('shared.chirpyest')}
              className={classes.logo}
            />
            <Typography variant="h1" align="center">
              {error ? error : t('notFound.title')}
            </Typography>
            <CHRButton
              label={t('notFound.buttonText')}
              onClick={() => navigate(ROUTES.home)}
              customStyle={classes.button}
            />
          </div>
        </CHRContentContainer>
      </CHRSectionContainer>
    </Layout>
  )
}
export default withTranslation()(NotFoundPage)
